// src/config/environments.js
// Configuración de ambientes para el frontend (HTTP/HTTPS) - Compatible CRA + NEXT_PUBLIC

const pick = (a, b, fallback) => a || b || fallback;

const environments = {
  development: {
    name: 'development',
    apiBaseUrl: pick(
      process.env.REACT_APP_API_URL,
      process.env.NEXT_PUBLIC_API_URL,
      'https://dev-api.thejanway.com/', // local/dev sin SSL si querés
    ),
    wsBaseUrl: pick(
      process.env.REACT_APP_WS_URL,
      process.env.NEXT_PUBLIC_WS_URL,
      'ws://dev-api.thejanway.com/ws',
    ),
    environment: 'development',
    debug: true,
    features: {
      enableDebugMode: true,
      enableMockData: process.env.REACT_APP_ENABLE_MOCK_DATA === 'true',
      enableErrorReporting: false,
    },
  },

  staging: {
    name: 'staging',
    // ⚠️ Para staging/preview en Vercel (frontend en https), usa https/wss para evitar Mixed Content
    apiBaseUrl: pick(
      process.env.REACT_APP_API_URL,
      process.env.NEXT_PUBLIC_API_URL,
      'https://dev-api.thejanway.com/',
    ),
    wsBaseUrl: pick(
      process.env.REACT_APP_WS_URL,
      process.env.NEXT_PUBLIC_WS_URL,
      'wss://dev-api.thejanway.com/ws',
    ),
    environment: 'staging',
    debug: true,
    features: {
      enableDebugMode: true,
      enableMockData: false,
      enableErrorReporting: true,
    },
  },

  production: {
    name: 'production',
    // Producción final: https/wss via Cloudflare
    apiBaseUrl: pick(
      process.env.REACT_APP_API_URL,
      process.env.NEXT_PUBLIC_API_URL,
      'https://api.thejanway.com/',
    ),
    wsBaseUrl: pick(
      process.env.REACT_APP_WS_URL,
      process.env.NEXT_PUBLIC_WS_URL,
      'wss://api.thejanway.com/ws',
    ),
    environment: 'production',
    debug: false,
    features: {
      enableDebugMode: false,
      enableMockData: false,
      enableErrorReporting: true,
    },
  },
};

export const getEnvironmentConfig = () => {
  const env =
    process.env.REACT_APP_ENVIRONMENT ||
    process.env.NEXT_PUBLIC_ENVIRONMENT ||
    process.env.NODE_ENV ||
    'development';

  return environments[env] || environments.development;
};

export const getConfig = (key) => getEnvironmentConfig()[key];

export const isDevelopment = () => getEnvironmentConfig().environment === 'development';
export const isStaging = () => getEnvironmentConfig().environment === 'staging';
export const isProduction = () => getEnvironmentConfig().environment === 'production';

export const getApiUrl = () => getEnvironmentConfig().apiBaseUrl;
export const getWsUrl = () => getEnvironmentConfig().wsBaseUrl;

export const config = getEnvironmentConfig();
export default config;
